/* eslint-disable no-undef */
import { useState, createContext, useContext } from 'react';
import { trueApi } from '../services/api';
import { variables, encryptor } from '../configuration/Constants';

interface AuthContextData {
  accessToken: string | null;
  setAccessToken: any;
  createToken: any;
  logout: () => void;
}

const AuthContext = createContext<AuthContextData>({} as any);

export function AuthProvider({ children } : any) {
  const [accessToken, setAccessToken] = useState(() => (sessionStorage.getItem('@GR:token')));

  async function createToken(email: string, password: string) {
    try {
      // const tokenData = await trueApi.post('/auth/token', { user: 'gr', senha: 'gr@2022' });
      // sessionStorage.setItem('@GR:token', tokenData.data.AccessToken);
      sessionStorage.setItem('@GR:token', 'placeholder');
      let validation = {} as any;

      const response = await trueApi.post('/acesso/login', { email, senha: password }, {
        headers: {
          // Authorization: `Bearer ${tokenData.data.AccessToken}`,
        } });
      validation = response.data;
      console.log(validation);
      if (validation.Status) {
        sessionStorage.setItem('id', validation.Codigo);
        const permissions = await trueApi.get(`/usuario/associados?id=${validation.Codigo}`, {
          headers: {
            // Authorization: `Bearer ${tokenData.data.AccessToken}`,
          },
        });
        // console.log(permissions);
        sessionStorage.setItem('@GR:permissions', encryptor.encrypt(JSON.stringify(permissions.data.lista)));
        const token = sessionStorage.getItem('@GR:token');
        setAccessToken(token);
        return true;
      }
      throw new Error();
    } catch (error) {
      console.log('Erro em criar token', error);
      return false;
    }
  }

  function logout() {
    sessionStorage.removeItem('@GR:token');
    sessionStorage.removeItem('@GR:permissions');
    sessionStorage.removeItem('id');
    window.location.reload();
  }

  return (
    <AuthContext.Provider value={{ createToken, accessToken, setAccessToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);

  return context;
}
